import { WarningCircleIcon } from '@phosphor-icons/react'
import * as Dialog from '@radix-ui/react-dialog'
import type { Repository, WorkflowResponse } from '../../utils/api-client/api-schemas.ts'
import { DefaultButton } from '../buttons/default-button.tsx'
import { GhostButton } from '../buttons/ghost-button.tsx'
import * as sharedStyles from '../drawers/workflow-shared.css.ts'
import { SCMIcon } from '../third-party-branding/scm-icon.tsx'

export type DeleteWorkflowModalProps = {
  workflow: WorkflowResponse | undefined
  repositoryType: Repository['type']
  repositoryDisplayName: string
  onCancel: () => unknown
  onConfirm: (workflowId: string) => unknown
}

export const DeleteWorkflowModal: React.FC<DeleteWorkflowModalProps> = ({
  workflow,
  repositoryType,
  repositoryDisplayName,
  onCancel,
  onConfirm,
}) => (
  <Dialog.Root open={!!workflow} onOpenChange={() => onCancel()}>
    <Dialog.Portal>
      <Dialog.Overlay className={sharedStyles.dialogOverlay} />
      <Dialog.Content className={sharedStyles.dialogContent}>
        <Dialog.Title className={sharedStyles.dialogTitle}>
          <WarningCircleIcon className={sharedStyles.destructiveIcon} size={32} weight="fill" aria-hidden={true} />
          Delete workflow?
        </Dialog.Title>
        <Dialog.Description className={sharedStyles.dialogMiddle}>
          <div className={sharedStyles.dialogMessage}>You are about to delete the following workflow:</div>
          <div className={sharedStyles.dialogSubtitle}>
            <div className={sharedStyles.dialogRepoInfo}>
              <SCMIcon type={repositoryType} size="medium" />
              <span>{repositoryDisplayName}</span>
            </div>
            <div className={sharedStyles.workflowName}>{workflow?.name || 'Unnamed workflow'}</div>
          </div>
          <div className={sharedStyles.dialogMessage}>This action cannot be undone. Do you wish to proceed?</div>
        </Dialog.Description>
        <div className={sharedStyles.dialogButtons}>
          <GhostButton type="secondary" onClick={onCancel}>
            Cancel
          </GhostButton>
          <DefaultButton
            buttonType="destructive"
            onClick={() => {
              if (workflow) {
                onConfirm(workflow.id)
              }
            }}
          >
            Delete workflow
          </DefaultButton>
        </div>
      </Dialog.Content>
    </Dialog.Portal>
  </Dialog.Root>
)
